// Redux connect wrapper for RumUserSync component
// This component is used to sync user data with Datadog

import { connect } from 'react-redux'
import RumUserSync from './RumUserSync'
import { getIsEmployeeUserLoggedInRatherThanCustomerUser } from '../../redux/selectors/currentUserEmployee'

const mapState = state => ({
  isAuthenticated: state.authentication?.isAuthenticated,
  isEmployeeUserLoggedInRatherThanCustomerUser:
    getIsEmployeeUserLoggedInRatherThanCustomerUser(state),
  currentUser: state?.currentUser,
  currentUserEmployee: state?.currentUserEmployee,
})

export default connect(mapState)(RumUserSync)
